import {
  DatagridConfigurable,
  List,
  TextField,
  SearchInput,
  TopToolbar,
  SelectColumnsButton,
  CreateButton,
  required,
  DateField,
  WrapperField,
  DeleteWithConfirmButton,
  SelectInput,
} from "react-admin";

import { ListNoResultsWithFilters } from "@/components/ListNoResultsWithFilters";
import { ListPaginationByLimit } from "@/components/pagination";
import {
  CLIENT_SEARCH_SOURCE,
  FILTER_LIMIT_OPTIONS,
  FILTER_LIMITS,
} from "@/constants/filters";

const ListActions = () => (
  <TopToolbar>
    <SelectColumnsButton />
    <CreateButton />
  </TopToolbar>
);

const DEFAULT_FILTERS = {
  limit: FILTER_LIMITS[0],
};

export const BlacklistDevicesList = () => (
  <List
    filters={[
      <SearchInput
        key="search"
        placeholder="Search Device by Page"
        source={CLIENT_SEARCH_SOURCE}
        alwaysOn
      />,
      <SelectInput
        key="limit"
        label="Limit"
        source="limit"
        choices={FILTER_LIMIT_OPTIONS}
        validate={required()}
        alwaysOn
      />,
    ]}
    storeKey={false}
    filterDefaultValues={DEFAULT_FILTERS}
    actions={<ListActions />}
    pagination={<ListPaginationByLimit />}
  >
    <DatagridConfigurable
      bulkActionButtons={false}
      empty={<ListNoResultsWithFilters defaultFilters={DEFAULT_FILTERS} />}
      omit={["createdAt", "updatedAt"]}
    >
      <TextField source="deviceId" />
      <DateField source="createdAt" showTime />
      <DateField source="updatedAt" showTime />

      <WrapperField label="Delete" sortable={false} textAlign="right">
        <DeleteWithConfirmButton />
      </WrapperField>
    </DatagridConfigurable>
  </List>
);
